import React, { useState, useEffect } from 'react';
import { Plug, ChevronRight } from 'lucide-react';
import { carsysApi } from '../api/carsysApi';
import { useT } from '../context/LanguageContext';

const BASIC_KEYS = ['gemini', 'email', 'stripe'];
const PRO_KEYS = ['twilio', 'storecove'];

export const IntegrationsStatusWidget = ({ onNavigate }) => {
  const { t } = useT();
  const [data, setData] = useState(null);
  useEffect(() => { carsysApi.getIntegrationsOverview().then(setData).catch(() => setData(null)); }, []);

  if (!data) return null;
  const keys = data.licensed ? [...BASIC_KEYS, ...PRO_KEYS] : BASIC_KEYS;
  const st = data.status || {};
  const done = keys.filter(k => st[k]).length;
  const total = keys.length;
  const pct = total ? Math.round((done / total) * 100) : 0;
  const allDone = done === total;
  // Bij alles gekoppeld/uitgeschakeld (100%) verdwijnt de widget van het dashboard.
  if (allDone) return null;

  return (
    <button data-testid="dashboard-integrations-widget" onClick={() => onNavigate('integraties')} style={wrap}>
      <div style={iconBadge}><Plug size={18} /></div>
      <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
        <div style={{ fontWeight: 700, fontSize: 13.5, color: '#0f172a' }}>{t('Integraties', 'Integraties')}</div>
        <div style={{ fontSize: 12, color: '#64748b' }} data-testid="dashboard-integrations-count">
          {`${done}/${total} ${t('gekoppeld', 'gekoppeld')}`}
        </div>
        <div style={barTrack}><div style={{ ...barFill, width: `${pct}%`, background: '#2563eb' }} /></div>
      </div>
      <ChevronRight size={16} color="#94a3b8" />
    </button>
  );
};

const wrap = { display: 'flex', alignItems: 'center', gap: 12, width: '100%', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '12px 14px', cursor: 'pointer', boxShadow: '0 1px 3px rgba(15,23,42,.04)' };
const iconBadge = { width: 36, height: 36, borderRadius: 9, background: '#eff6ff', color: '#2563eb', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 };
const barTrack = { height: 5, background: '#e2e8f0', borderRadius: 99, overflow: 'hidden', marginTop: 6 };
const barFill = { height: '100%', borderRadius: 99, transition: 'width 300ms ease' };
